/*==========================================================
HTML CLASSES SCRIPT
==========================================================*/
var topNavAdjust = false;

function checkTopNavMobile() {
    if (topNavAdjust) {
        topNavReset();
    }

    if (Modernizr.mq('only screen and (max-width: 991px)') && (Modernizr.touch) || Modernizr.mq('only all and (max-width: 991px)')) {
        topNavMobile();
    }
}

function topNavMobile() {
    if (!topNavAdjust) {
        if ($('#topNav').length) {
            $('#topNav').children().detach().appendTo('#nav').wrap('<li class="topNavMobile" />');
        }

        if ($('#idLikeTo').length) {
            $('#idLikeTo').detach().appendTo('#nav').wrap('<li />');
        }

        if ($('.searchContainer').length) {
            $('.searchContainer').detach().appendTo('#nav').wrap('<li />');
        }

        topNavAdjust = true;
    }
}

function topNavReset() {
    if (topNavAdjust) {
        topNavAdjust = false;

        if ($('#topNav').length) {
            $('.topNavMobile').children().unwrap('li').detach().prependTo('#topNav');
        }

        if ($('#idLikeTo').length) {
            $('#idLikeTo').unwrap('li').detach().insertAfter('#translateContainer');
        }

        if ($('.searchContainer').length) {
            $('.searchContainer').unwrap('li').detach().appendTo('#headerRight');
        }
    }
}

$(window).load(function() {
    checkTopNavMobile();
});

//debounce resize instead of standard resize
$(window).debounceResize(function() {
    checkTopNavMobile();
});

$(function() {
    checkTopNavMobile();
});